var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6ae79bc04952205888a07bf10dff7ab.js').default;export default
        Object.assign({}, scope_0 )
    